import { BaseRepository } from "@/repositories/base-repository.ts"
import type { IIncomingInvoiceRentalIntakeMaterialization } from "@/interfaces/api/incoming-invoice-rental-intake-materialization.interface.ts"

export class IncomingInvoiceRentalIntakeMaterializationRepository extends BaseRepository<IIncomingInvoiceRentalIntakeMaterialization> {
  protected resourcePath = "administration/incoming-invoices-rental-intake-materializations"
}
